module.exports = __webpack_public_path__ + "static/img/SCDC100-banner.3960ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-4/SCDC100-banner.png
// module id = 9u7e
// module chunks = 0